(function () {
  'use strict';

  // GraphQL-Query, um gezielte Metafelder und deren Referenzen (Metaobjects) abzufragen
  const SECURE_METAFIELD_QUERY = `
    query GetSecureMetafields($productId: ID!, $identifiers: [HasMetafieldsIdentifier!]!) {
      node(id: $productId) {
        ... on Product {
          metafields(identifiers: $identifiers) {
            namespace
            key
            value
            type
            reference {
              ... on Metaobject {
                id
                handle
                fields { key value }
              }
            }
            references(first: 20) {
              edges {
                node {
                  ... on Metaobject {
                    id
                    handle
                    fields { key value }
                  }
                }
              }
            }
          }
        }
      }
    }
  `;

  function escapeHtml(str) {
    if (!str) return '';
    const node = document.createElement('div');
    node.appendChild(document.createTextNode(String(str)));
    return node.innerHTML;
  }

  // Findet den passenden Anzeigenamen für ein Metaobject aus seinen Feldern
  function getMetaobjectName(metaobject) {
    if (!metaobject || !metaobject.fields) return '';
    const fields = metaobject.fields;
    const nameField = fields.find(f => f.key === 'display_name' || f.key === 'name' || f.key === 'label');
    return nameField ? nameField.value : (fields[0]?.value || '');
  }

  async function initSecureMetafields(container) {
    const table = container.querySelector('[data-metafields-table]');
    const rows = container.querySelectorAll('[data-metafield-row]');
    const shopDomain = container.dataset.shopDomain;
    const storefrontToken = container.dataset.storefrontToken;
    const productId = `gid://shopify/Product/${container.dataset.productId}`;

    if (!shopDomain || !storefrontToken || rows.length === 0) {
      container.remove(); // Unkonfiguriert oder leer -> weg damit
      return;
    }

    // 1. Identifiers für GraphQL vorbereiten aus den vorhandenen DOM-Zeilen
    const identifiers = Array.from(rows).map(row => ({
      namespace: row.dataset.namespace,
      key: row.dataset.key
    }));

    const endpoint = `https://${shopDomain}/api/2025-01/graphql.json`;

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': storefrontToken,
        },
        body: JSON.stringify({
          query: SECURE_METAFIELD_QUERY,
          variables: { productId, identifiers }
        }),
      });

      if (!response.ok) throw new Error('Network error');

      const { data } = await response.json();
      const returnedMetafields = data?.node?.metafields || [];

      let visibleRowsCount = 0;

      // 2. Durch alle vorbereiteten Zeilen loopen und mit API-Daten abgleichen
      rows.forEach(row => {
        const ns = row.dataset.namespace;
        const key = row.dataset.key;
        const enableLink = row.dataset.enableLink === 'true';
        const collectionUrl = row.dataset.collectionUrl;
        const valueContainer = row.querySelector('[data-metafield-placeholder]');

        // Finde das zugehörige Metafeld aus der API-Antwort
        const apiData = returnedMetafields.find(m => m && m.namespace === ns && m.key === key);

        // NATIVE REGELUNG: Wenn das Metafeld in der API gesperrt ist, existiert es in apiData nicht oder ist null
        if (!apiData || !apiData.value) {
          row.remove(); // Löscht die Zeile restlos aus dem DOM
          return;
        }

        // Wenn wir hier angekommen sind, ist das Feld freigegeben. Wir bereiten das HTML vor:
        visibleRowsCount++;
        let htmlContent = '';

        // Fall A: Einzelnes Metaobject
        if (apiData.type === 'metaobject_reference' && apiData.reference) {
          const name = getMetaobjectName(apiData.reference);
          const fullGid = encodeURIComponent(apiData.reference.id);
          
          if (enableLink && collectionUrl) {
            htmlContent = `<a href="${collectionUrl}?filter.p.m.${ns}.${key}=${fullGid}" class="product-metafilter__link">${escapeHtml(name)}</a>`;
          } else {
            htmlContent = `<span>${escapeHtml(name)}</span>`;
          }
        } 
        // Fall B: Liste von Metaobjects oder normalen Werten
        else if (apiData.type.includes('list.')) {
          let parsedItems = [];
          try { parsedItems = JSON.parse(apiData.value); } catch(e) { parsedItems = []; }

          if (apiData.type.includes('metaobject_reference') && apiData.references?.edges) {
            const links = apiData.references.edges.map(edge => {
              const node = edge.node;
              const name = getMetaobjectName(node);
              const fullGid = encodeURIComponent(node.id);
              if (enableLink && collectionUrl) {
                return `<a href="${collectionUrl}?filter.p.m.${ns}.${key}=${fullGid}" class="product-metafilter__link">${escapeHtml(name)}</a>`;
              }
              return `<span>${escapeHtml(name)}</span>`;
            });
            htmlContent = links.join('<span aria-hidden="true">, </span>');
          } else {
            // Normale Liste (z.B. list.single_line_text_field)
            const listItems = parsedItems.map(item => {
              if (enableLink && collectionUrl) {
                return `<a href="${collectionUrl}?filter.p.m.${ns}.${key}=${encodeURIComponent(item)}" class="product-metafilter__link">${escapeHtml(item)}</a>`;
              }
              return `<span>${escapeHtml(item)}</span>`;
            });
            htmlContent = listItems.join('<span aria-hidden="true">, </span>');
          }
        } 
        // Fall C: Standard Text / Zahl / Dimension
        else {
          if (enableLink && collectionUrl) {
            htmlContent = `<a href="${collectionUrl}?filter.p.m.${ns}.${key}=${encodeURIComponent(apiData.value)}" class="product-metafilter__link">${escapeHtml(apiData.value)}</a>`;
          } else {
            htmlContent = `<span>${escapeHtml(apiData.value)}</span>`;
          }
        }

        // Werte in die Spalte einsetzen
        if (valueContainer) {
          valueContainer.innerHTML = htmlContent;
        }
      });

      // Wenn absolut kein Metafeld für die API freigegeben war, verstecken wir die ganze Sektion
      if (visibleRowsCount === 0) {
        container.remove();
      } else if (table) {
        table.style.opacity = '1'; // Tabelle elegant einblenden, wenn geladen
      }

    } catch (error) {
      console.error('Error validation storefront fields:', error);
      container.remove(); // Bei Fehlern sicherheitshalber ausblenden
    }
  }

  // Init für alle entsprechenden Blöcke auf der Seite
  document.querySelectorAll('[data-secure-metafields]').forEach(initSecureMetafields);
})();